module.exports = __webpack_public_path__ + "media/images/edion/popular/3-04abe6d83c6308eec671e2bad0033a10.png";